export const DEFAULT_DATASET_NAME = "Untitled Dataset";
